export * from "./basic-info-register/basic-info-register.component";
export * from "./document-upload/document-upload.component";
export * from "./otp-verify/otp-verify.component";
